export const sounds = [
    {title: "Pausetta", url: 'sounds/pausetta.mp3'},
    {title: "Zuppetta", url: 'sounds/zuppetta.mp3'},
    {title: "Quadernetto", url: 'sounds/quadernetto.mp3'},
    {title: "Foglietto", url: 'sounds/foglietto.mp3'},
    {title: "Libretto", url: 'sounds/libretto.mp3'},
    {title: "Stufetta", url: 'sounds/stufetta.mp3'},
    {title: "Caffettino", url: 'sounds/caffettino.mp3'},
    {title: "Pacchetto", url: 'sounds/pacchetto.mp3'},
    {title: "Stringhetta", url: 'sounds/stringhetta.mp3'},
    {title: "Pezzetto", url: 'sounds/pezzetto.mp3'},
]

export const specials = [
    {title: "Ma dove vi porto", url: 'sounds/dove_vi_porto.mp3'},
    {title: "Poi vediamo", url: 'sounds/poi_vediamo.mp3'},
    {title: "Tanto decide il frontend", url: 'sounds/decide-fe.mp3'},
    {title: "Sono davanti ad un muro", url: 'sounds/muro.mp3'},
    {title: "Che disagio", url: 'sounds/disagio.mp3'},
    {title: "Altra destra", url: 'sounds/altra_destra.mp3'},
    {title: "Altra sinistra", url: 'sounds/altra_sinistra.mp3'},
    {title: "Edgar", url: 'sounds/edghy.mp3'},
    {title: "Sylvia", url: 'sounds/syl.mp3'},
]
